module.exports = __webpack_public_path__ + "static/img/SVX.c5de15a.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SVX.png
// module id = bqa9
// module chunks = 1